import { MantineStyleProps } from '@mantine/core';
import { DynamicUiEntitiesMetadata } from 'src/UI/dynamicUI/types';
import { BaseFinancialItem, Liability } from 'src/financial/financial-data/hooks/useFinancialItems';
import {
  FinancialItemGenericTable,
  formatDate,
  getFinancialItemType,
} from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { formatCurrency } from 'src/cashflows/utils';

type AccountsTableProps = {
  liabilities: Liability[];
  metadata: DynamicUiEntitiesMetadata;
  pl?: MantineStyleProps['pl'];
  pr?: MantineStyleProps['pr'];
  titleParts?: string[];
  onSubmit: () => void;
  onRowClick: (clickedItem: BaseFinancialItem) => void;
};

export default function LiabilitiesTable({
  liabilities,
  metadata,
  pl = 50,
  pr = 112,
  onRowClick,
}: AccountsTableProps) {
  const fieldsRenderingRules = [
    {
      headerTitle: 'Description',
      render: (item: Liability) => item.description,
    },
    {
      headerTitle: 'Provider',
      render: (item: Liability) => item.provider || '',
    },
    {
      headerTitle: 'Type',
      render: (item: Liability) => getFinancialItemType(item, metadata),
    },
    {
      headerTitle: 'Remaining balance date',
      render: (item: Liability) => formatDate(item.remainingBalanceDate),
    },
    {
      headerTitle: 'Remaining balance',
      render: (item: Liability) => formatCurrency(item.remainingBalance),
    },
  ];

  return (
    <>
      <FinancialItemGenericTable
        financialItems={liabilities}
        fieldsRenderingRules={fieldsRenderingRules}
        pl={pl}
        pr={pr}
        onRowClick={onRowClick}
      />
    </>
  );
}
